import ConfigFile from "../../../datasets/config_file";

export const intRatCreditScoreLit = (intRate, loanType, creditScore) => {
    
    let loanTypeText = "";
    let baseRate = 0;
    if (loanType === "house"){
        baseRate = +(ConfigFile.homeItems.mortgageInterest);
        loanTypeText = "mortgage";
    }else{
        baseRate = +(ConfigFile.carItems.carInterest);
        loanTypeText = "car loan";
    }
    let text = "";
    if (baseRate < intRate){
        text = "increased";
    }else{
        text = "reduced";
    }
    let displayText = "Your " + loanTypeText + " interest rate has been " + text + " based on " +
        "your current credit score of " + creditScore + ". ";
    if (creditScore < 760){
        if (text === "reduced"){
            displayText += "You can qualify for an even lower interest rate if you improve your credit score."
        }else{
            displayText += "Improving your credit score will help lower your interest rate."
        }
    }else{
        displayText += "Your credit score has qualified you for the best possible rates."
    }
    const displayIntRate = (+intRate * 100).toFixed(2) + "%"
    displayText += " Interest rate is: " + displayIntRate + ".";
    return displayText;
}
export default intRatCreditScoreLit;